<template>
  <div class="mportal-mb-5 mportal-bg-red-500 mportal-pt-2 mportal-pb-2">
    <b class="mportal-text-white">
      Diese Seite wird nur für Demo Zwecke verwendet - Die Fahrzeuge stehen nicht zum Verkauf - This case study was developed for demonstration purposes only
    </b>
  </div>
  <div v-if="view === 'error'" class="mportal-ml-1.5 mportal-w-full">
    <h1 class="mportal-text-2xl mportal-my-8">Es wurde kein Händler ausgewählt.</h1>
  </div>
  <div v-if="view === 'listing'" class="mportal-ml-1.5 mportal-w-full">
    <div>
      <!-- Mobile filter dialog -->
      <TransitionRoot as="template" :show="mobileFiltersOpen">
        <Dialog as="div" class="mportal-fixed mportal-inset-0 mportal-flex z-40 lg:mportal-hidden" @close="mobileFiltersOpen = false">
          <TransitionChild as="template" enter="mportal-transition-opacity mportal-ease-linear mportal-duration-300" enter-from="mportal-opacity-0" enter-to="mportal-opacity-100" leave="mportal-transition-opacity mportal-ease-linear mportal-duration-300" leave-from="mportal-opacity-100" leave-to="mportal-opacity-0">
            <DialogOverlay class="mportal-fixed mportal-inset-0 mportal-bg-black mportal-bg-opacity-25" />
          </TransitionChild>

          <TransitionChild as="template" enter="mportal-transition mportal-ease-in-out mportal-duration-300 mportal-transform" enter-from="mportal-translate-x-full" enter-to="mportal-translate-x-0" leave="mportal-transition mportal-ease-in-out mportal-duration-300 mportal-transform" leave-from="mportal-translate-x-0" leave-to="mportal-translate-x-full">
            <div class="mportal-ml-auto mportal-relative mportal-max-w-xs mportal-w-full mportal-h-full mportal-bg-white mportal-shadow-xl mportal-py-4 mportal-pb-12 mportal-flex mportal-flex-col mportal-overflow-y-auto">
              <div class="mportal-px-4 mportal-flex mportal-items-center mportal-justify-between">
                <button type="button" class="mportal-mr-2 mportal-w-10 mportal-h-10 mportal-bg-white mportal-p-2 mportal-rounded-md mportal-flex mportal-items-center mportal-justify-center mportal-text-black-400" @click="mobileFiltersOpen = false">
                  <span class="mportal-sr-only">Close menu</span>
                  <XIcon class="mportal-h-6 mportal-w-6" aria-hidden="true" />
                </button>
              </div>

              <!-- Filters mobile-->
              <form class="mportal-mt-4 mportal-border-t mportal-border-gray-200">
                <h3 class="mportal-sr-only">Categories</h3>

                <Disclosure v-for="section in filters" :key="section.id" v-slot="{ open }" as="div" class="mportal-border-t mportal-border-gray-200 mportal-px-4 mportal-py-6">
                  <h3 class="mportal-mx-2 mportal-my-3 mportal-flow-root">
                    <DisclosureButton class="mportal-px-2 mportal-pt-1 mportal-pb-3 mportal-bg-white mportal-w-full mportal-flex mportal-items-center mportal-justify-between mportal-text-black-600 hover:mportal-text-black-800">
                      <span class="mportal-font-medium mportal-text-black-900 mportal-text-left">
                        {{ section.name }}
                      </span>
                      <span class="mportal-ml-6 flex mportal-items-center">
                        <PlusSmIcon v-if="!open" class="mportal-h-5 mportal-w-5" aria-hidden="true" />
                        <MinusSmIcon v-else class="mportal-h-5 mportal-w-5" aria-hidden="true" />
                      </span>
                    </DisclosureButton>
                  </h3>
                  <DisclosurePanel class="mportal-pt-6">
                    <div class="smportal-pace-y-6">
                      <div v-for="(option, optionIdx) in section.options" :key="option.value" class="mportal-flex mportal-items-center mportal-text-left">
                        <input :id="`filter-mobile-${section.id}-${optionIdx}`" v-model="filterselected" :name="`${section.id}[]`" :value="option.value" type="checkbox" class="mportal-h-4 mportal-w-4 mportal-border-gray-600 mportal-rounded mportal-text-indigo-600 focus:mportal-ring-indigo-500" />
                        <label :for="`filter-mobile-${section.id}-${optionIdx}`" class="ml-3 min-w-0 flex-1 text-left text-gray-900">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </DisclosurePanel>
                </Disclosure>
              </form>
            </div>
          </TransitionChild>
        </Dialog>
      </TransitionRoot>

      <main class="mportal-w-full mportal-m-2 mportal-max-w-screen-2xl mportal-m-auto mportal-mt-0">
        <div class="mportal-relative mportal-z-10 mportal-flex mportal-items-baseline mportal-justify-between mportal-border-transparent">
          <div class="mportal-flex mportal-items-center">
            <button type="button" class="mportal-p-2 mportal-m-2 mportal-ml-5 sm:mportal-ml-7 mportal-text-black-400 hover:mportal-text-black-500">
              <span class="mportal-sr-only">View grid</span>
            </button>
            <button type="button" class="mportal-p-2 mportal-m-2 mportal-ml-4 sm:mportal-ml-6 mportal-text-black-400 hover:mportal-text-black-600 lg:mportal-hidden" @click="mobileFiltersOpen = true">
              <span class="mportal-sr-only">Filters</span>
              <span class="mportal-float-left">Filter</span> <FilterIcon class="mportal-w-5 h-5 mportal-float-left mportal-m-0.5" aria-hidden="true" />
            </button>
          </div>
        </div>

        <section aria-labelledby="products-heading" class="mportal-flex w-full mportal-float-left">
          <div v-if="view === 'listing'" class="mportal-float-left mportal-mr-10">
            <!-- Filters -->
            <form class="mportal-hidden lg:mportal-block">
              <h3 class="mportal-sr-only">Categories</h3>
              <Disclosure v-for="(section) in filters" :key="section.id" v-slot="{ open }" as="div" class="mportal-border-b mportal-border-gray-200 mportal-pt-4 mportal-pb-4">
                <h3 class="flow-root">
                  <DisclosureButton class="mportal-pt-1 mportal-bg-white mportal-w-full mportal-flex mportal-items-center mportal-justify-between mportal-text-base mportal-text-black-400 hover:mportal-text-black-500">
                    <span class="mportal-text-left mportal-font-medium mportal-text-black-900">
                      {{ section.name }}
                    </span>
                    <span class="mportal-ml-6 mportal-flex mportal-items-center">
                      <PlusSmIcon v-if="!open && !getFilterValues(section.options).some(v=> filterselected.includes(v))" class="mportal-h-5 mportal-w-5" aria-hidden="true" />
                      <MinusSmIcon v-else class="mportal-h-5 mportal-w-5" aria-hidden="true" />
                    </span>
                  </DisclosureButton>
                </h3>
                <div v-show="open || getFilterValues(section.options).some(v=> filterselected.includes(v))">
                  <DisclosurePanel static class="mportal-pt-3 mportal-px-1">
                    <div class="mportal-space-y-2">
                      <div v-for="(option, optionIdx) in section.options" :key="option.value" class="mportal-flex mportal-items-center">
                        <input :id="`filter-${section.id}-${optionIdx}`" v-model="filterselected" :name="`${section.id}[]`" :value="option.value" type="checkbox" class="mportal-h-4 mportal-w-4 mportal-border-gray-600 mportal-rounded mportal-text-indigo-800 focus:mportal-ring-indigo-500" />
                        <label :for="`filter-${section.id}-${optionIdx}`" class="mportal-ml-3 mportal-text-sm mportal-text-left mportal-text-black-800">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </DisclosurePanel>
                </div>
              </Disclosure>
            </form>
          </div>
          <!-- Product grid -->
          <!-- Listing -->
          <div v-if="view==='listing'" :class="[loadingListing ? 'mportal-hidden' : '' ]"><div class="mportal-lds-ellipsis-container"><div class="mportal-lds-ellipsis"><div /><div /><div /><div /></div></div></div>
          <div v-if="view === 'listing'" class="mportal-w-full mportal-cursor-pointer mportal-flex mportal-flex-wrap mportal-overflow-hidden">
            <div v-for="vehicle in hubdata" :key="vehicle.id" class="mportal-w-full md:mportal-w-1/2 lg:mportal-w-1/3 mportal-overflow-hidden" @click="gotToDetail(vehicle.vehicleNr)">
              <div class="mportal-p-5 mportal-m-auto mportal-mb-10" :class="[imagesLoaded.includes(vehicle.images.front) ? '' : 'mportal-hidden' ]">
                <div class="mportal-p-1 mportal-w-full">
                  <img :src="imgpath+vehicle.images.front" class="mportal-w-full mportal-mb-10 border-none" :alt="vehicle.description" rel="preload" @load="onLoadImage(vehicle.images.front)" />
                </div>
                <div>
                  <div class="mportal-mb-4 mportal-text-left mportal-text-2xl mportal-font-normal mportal-text-black mportal-w-full mportal-font-normal">
                    {{ vehicle.brandcode }} {{ vehicle.description }}
                  </div>
                </div>
                <div class="mportal-mt-4 mportal-mb-4">
                  <div class="mportal-w-full mportal-min-w-full mportal-text-lg mportal-text-left mportal-font-bold">{{ numberFormat(brutto(vehicle.privat_nettodarlehensbetrag, true)) }} € / {{ numberFormat(brutto(vehicle.privat_leasing_36_10, true)) }} € mtl.</div>
                </div>
                <div class="mportal-text-left mportal-mb-4 mportal-mr-9">
                  <table class="mportal-w-full mportal-font-normal mportal-text-black mportal-text-sm border-none">
                    <tr><td class="mportal-w-2/3 border-none">Leistung</td><td class="mportal-w-1/3 border-none">{{ vehicle.displayPower }} kW ({{ ps(vehicle.displayPower) }} PS)</td></tr>
                    <tr><td>Kraftstoff</td><td>{{ vehicle.fuelType }}</td></tr>
                    <tr><td>Getriebe</td><td>{{ vehicle.gearType }}</td></tr>
                    <tr v-if="vehicle.wltpFuelConsumptionComb"><td>Verbrauch (WLTP, komb.)</td><td>{{ vehicle.wltpFuelConsumptionComb }} l/100km</td></tr>
                    <tr v-if="vehicle.wltpFuelConsumptionWeightedComb"><td>Verbrauch (WLTP, komb.)</td><td>{{ vehicle.wltpFuelConsumptionWeightedComb }} l/100km</td></tr>
                    <tr v-if="vehicle.wltpFuelConsumptionChargeSustainingComb"><td>Verbrauch (WLTP, komb.)</td><td>{{ vehicle.wltpFuelConsumptionChargeSustainingComb }} l/100km</td></tr>
                    <tr v-if="vehicle.nedcFuelConsumptionCombined"><td>Verbrauch (NEFZ)</td><td>{{ vehicle.nedcFuelConsumptionCombined }} l/100km</td></tr>
                    <tr v-if="vehicle.wltpCo2Comb || vehicle.wltpPureElectricRangeComb"><td>CO²-Emission (WLTP)</td><td>{{ vehicle.wltpCo2Comb ? vehicle.wltpCo2Comb : '0' }} g/km</td></tr>
                    <tr v-if="vehicle.wltpCo2WeightedComb"><td>CO²-Emission (WLTP, gew., komb.)</td><td>{{ vehicle.wltpCo2WeightedComb }} g/km</td></tr>
                    <tr v-if="vehicle.wltpCo2ChargeSustainingComb"><td>CO²-Emission (WLTP, komb.)</td><td>{{ vehicle.wltpCo2ChargeSustainingComb }} g/km</td></tr>
                    <tr v-if="vehicle.nedcCo2Combined "><td>CO²-Emission (NEFZ)</td><td>{{ vehicle.nedcCo2Combined }} g/km</td></tr>
                    <tr v-if="vehicle.wltpEquivalentAllElectricRangeComb"><td>Elektrische Reichweite (WLTP, komb.)</td><td>{{ vehicle.wltpEquivalentAllElectricRangeComb }} km</td></tr>
                    <tr v-if="vehicle.wltpPureElectricRangeComb"><td>Elektrische Reichweite (WLTP, komb.)</td><td>{{ vehicle.wltpPureElectricRangeComb }} km</td></tr>
                    <tr v-if="vehicle.wltpPureElectricRangeCity"><td>Elektrische Reichweite (WLTP, innerorts)</td><td>{{ vehicle.wltpPureElectricRangeCity }} km</td></tr>
                    <tr v-if="vehicle.wltpElectricConsumptionAcWeightedComb"><td>Stromverbrauch (WLTP, komb.)</td><td>{{ vehicle.wltpElectricConsumptionAcWeightedComb }} kWh/100km</td></tr>
                    <tr v-if="vehicle.wltpElectricConsumptionComb"><td>Stromverbrauch (WLTP, komb.)</td><td>{{ vehicle.wltpElectricConsumptionComb }} kWh/100km</td></tr>
                    <tr v-if="vehicle.energyLabel===`Aplusplusplus`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-pr-1 mportal-pl-1 mportal-bg-green-600 mportal-max-w-xxxs mportal-text-white mportal-font-bold">A+++</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`Aplus` || vehicle.energyLabel===`AP`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-pr-1 mportal-pl-1 mportal-bg-green-600 mportal-max-w-xxxs mportal-text-white mportal-font-bold">A+</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`A`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-green-500 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">A</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`B`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-green-400 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">B</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`C`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-green-300 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">C</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`D`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-yellow-200 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">D</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`E`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-yellow-400 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">E</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`F`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-red-400 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">F</div></td></tr>
                    <tr v-if="vehicle.energyLabel===`G`"><td>CO²-Effizienzklasse</td><td class="mportal-float-right"><div class="mportal-bg-red-600 mportal-max-w-xxxs mportal-text-white mportal-font-bold mportal-px-1">G</div></td></tr>
                  </table>
                </div>
                <!--<div class="leasingbeispiel mb-2" v-html="vehicle.leasingbeispiel" />-->
                <div class="mportal-text-left mportal-mb-4 mportal-mr-9 mportal-mt-4">
                  <table class="mportal-w-full mportal-text-black mportal-text-sm">
                    <tr><td colspan="2">Leasingbeispiel der BMW Bank GmbH<sup>*</sup></td></tr>
                    <tr><td>Laufleistung p.a</td><td>10.000 km</td></tr>
                    <tr>
                      <td>Laufzeit</td><td>36 Monate</td>
                    </tr>
                    <tr><td>Leasingsonderzahlung</td><td>0 €</td></tr>
                    <tr><td>Anschaffungspreis</td><td>{{ numberFormat(brutto(vehicle.privat_nettodarlehensbetrag, true)) }} €</td></tr>
                    <tr><td>Gesamtbetrag</td><td>{{ numberFormat(brutto(vehicle.privat_gesamtleasingbetrag_36_10, true)) }} €</td></tr>
                    <tr><td>Leasingrate monatlich</td><td>{{ numberFormat(brutto(vehicle.privat_leasing_36_10, true)) }} €</td></tr>
                  </table>
                </div>
                <div v-if="vehicle.delivery" class="mportal-text-left">
                  <span class="mportal-rounded mportal-p-2 mportal-font-bold mportal-delivery mportal-text-sm mportal-border" style="border-color: rgba(52,103,205,0.75)">
                    {{ vehicle.delivery }}
                  </span>
                </div>
                <!--
                <div class="mportal-max-w-xs mportal-text-justify mportal-mr-9 mportal-text-black-700 mportal-mb-10 mportal-text-base">
                  Ein unverbindliches Leasingbeispiel der BMW Bank GmbH, Lilienthalallee 26, 80939 München; alle Preise inkl. MwSt.; Stand {{ now }} Ist der Leasingnehmer Verbraucher, besteht nach Vertragsschluss ein gesetzliches Widerrufsrecht. Nach den Leasingbedingungen besteht die Verpflichtung, für das Fahrzeug eine Vollkaskoversicherung abzuschließen.
                  * gebunden für die gesamte Vertragslaufzeit.
                </div>//-->
              </div>
            </div>
            <div class="mportal-w-full mportal-py-4 mportal-px-2 mportal-text-gray-600 mportal-text-sm">
              <br /><br />
              <sup>*</sup> unverbindliches Leasingbeispiel der BMW Bank GmbH, Lilienthalallee 26, 80939 München; alle Preise inkl. MwSt.; Stand {{ now }} Ist der Leasingnehmer Verbraucher, besteht nach Vertragsschluss ein gesetzliches Widerrufsrecht. Nach den Leasingbedingungen besteht die Verpflichtung, für das Fahrzeug eine Vollkaskoversicherung abzuschließen.
              * gebunden für die gesamte Vertragslaufzeit.
              <br /><br />
            </div>
            <!-- /End Listing -->
          </div>
        </section>
      </main>
    </div>
  </div>
  <transition name="slide-fade">
    <div>
      <div v-if="view==='detail'" :class="[detailImagesArr.every(v => imagesLoaded.includes(v)) ? 'mportal-hide' : '' ]"><div class="mportal-lds-ellipsis-container"><div class="mportal-lds-ellipsis"><div /><div /><div /><div /></div></div></div>
      <div v-if="view==='detail'" id="u-details" class="mportal-max-w-7xl mportal-m-auto mportal-mb-10" :class="[detailImagesArr.every(v => imagesLoaded.includes(v)) ? '' : 'mportal-opacity-0' ]">
        <div class="mportal-flex mportal-flex-wrap mportal-overflow-hidden mportal-m-4">
          <div class="mportal-w-full">
            <div class="mportal-btn-back-icon mportal-cursor-pointer" />
            <button class="mportal-float-left mportal-py-2 mportal-font-semibold mportal-text-smcursor-pointer" @click="backButton">&nbsp;Zurück</button>
          </div>
        </div>
        <div class="mportal-flex mportal-flex-wrap mportal-overflow-hidden mportal-m-4">
          <div class="mportal-w-full">
            <div class="md:mportal-text-5xl mportal-text-2xl mportal-text-left mportal-font-normal mportal-description">
              {{ detailArray.description }}
            </div>
            <div class="mportal-mt-2 mportal-text-left mportal-font-normal mportal-vehiclenumber">
              Angebotsnummer: {{ detailArray.vehicleNr }}
            </div>
            <div class="mportal-text-left mportal-font-normal mportal-text-white">
              {{ detailArray.modelCode }}
            </div>
          </div>
        </div>
        <div class="mportal-flex mportal-flex-wrap mportal-overflow-hidden mportal-m-4">
          <div class="mportal-w-full lg:mportal-w-3/4 lg:mportal-pr-8 mportal-mb-8">
            <div class="buehne">
              <VueAgile ref="main" class="main" :options="options1" :as-nav-for="asNavFor1">
                <div v-for="(slide, index) in detailImagesArr" :key="index" class="slide" :class="`slide--${index}`"><img :src="slide" rel="preload" @load="onLoadImage(slide)" /></div>
              </VueAgile>
            </div>
            <div class="thumbs">
              <VueAgile ref="thumbnails" class="thumbnails" :options="options2" :as-nav-for="asNavFor2">
                <div v-for="(slide, index) in detailImagesArr" :key="index" class="slide--thumbniail" @click="$refs.main.goTo(index)"><img :src="slide" rel="preload" /></div>
              </VueAgile>
            </div>
            <div class="navigation">
              <template slot="prevButton"><i class="fas fa-chevron-left" /></template>
              <template slot="nextButton"><i class="fas fa-chevron-right" /></template>
            </div>
          </div>
          <div class="mportal-w-full lg:mportal-w-1/4 mportal-text-2xl mportal-text-left mportal-font-normal">
            <div>
              <div class="mportal-text-lg mportal-leading-none mportal-originalpricetotal">
                {{ numberFormat(brutto(detailArray.privat_nettodarlehensbetrag, true)) }} €
              </div>
              <div class="mportal-text-sm mportal-leading-none mportal-my-2 mportal-pricenetto">
                {{ numberFormat(detailArray.privat_nettodarlehensbetrag) }} € netto
              </div>
              <div class="mportal-text-lg mportal-leading-none mportal-mt-6 mportal-leasing-pm">
                {{ numberFormat(brutto(detailArray.privat_leasing_36_10, true)) }} € / Mon. Leasing
              </div>
              <div class="mportal-text-sm mportal-leading-none mportal-my-2 mportal-leasing-netto">
                {{ numberFormat(detailArray.privat_leasing_36_10) }} € / Mon. Leasing netto
              </div>
              <div v-if="detailArray.delivery" class="mportal-text-left mportal-mt-4">
                <span class="mportal-w-full mportal-rounded mportal-p-2 mportal-font-bold mportal-delivery mportal-text-sm mportal-border" style="border-color: rgba(52,103,205,0.75)">
                  {{ detailArray.delivery }}
                </span>
              </div>
              <div class="mportal-my-8" />
              <div class="mportal-grid mportal-grid-cols-2 mportal-text-left mportal-text-base mportal-teaser">
                <div class="mportal-text-left mportal-mb-2">Getriebe</div><div class="mportal-text-right">{{ detailArray.gearType }}</div>
                <div class="mportal-text-left  mportal-mb-2">Kilometer</div><div class="mportal-text-right">0 Km</div>
                <div class="mportal-text-left  mportal-mb-2">Kraftstofftyp</div><div class="mportal-text-right">{{ detailArray.fuelType }}</div>
                <div class="mportal-text-left  mportal-mb-2">Antrieb</div><div class="mportal-text-right">{{ detailArray.driveType }}</div>
                <div v-if="detailArray.colourCode" class="mportal-text-left mportal-mb-2">Farbe</div><div class="mportal-text-right">{{ detailArray.colourCode }}</div>
                <div v-if="detailArray.upholsteryCode" class="mportal-text-left mportal-mb-2">Polster</div><div class="mportal-text-right">{{ detailArray.upholsteryCode }}</div>
              </div>
              <div v-if="detailArray.provisioning" class="mportal-mt-2 mportal-w-full mportal-text-left mportal-text-base">zzgl. Transportkosten i.H.v. {{ numberFormat(detailArray.provisioning) }} €</div>
              <div>
                <div class="mportal-text-base mportal-my-8 mportal-mailbutton">
                  <div class="mportal-bg-bmwBlue mportal-p-4 mportal-text-center mportal-text-white mportal-font-bold mportal-w-full mportal-cursor-pointer" @click="showAnfrage()">Angebot anfragen</div>
                </div>
              </div>
              <!--
              <div class="mportal-max-w-md mportal-telefon">
                <a href="tel:05222123456789" target="_new"><div class="mportal-max-w-xs mportal-cursor-pointer"><div class="mportal-tel-btn" /><div class="mportal-text-lg mportal-mx5">05222-123456789</div></div></a>
              </div>-->
            </div>
          </div>
        </div>
        <div class="md:mportal-text-4xl mportal-text-2xl mportal-mx-4 mportal-mt-16 mportal-text-left mportal-font-normal mportal-w-full">
          <div class="mportal-my-4">
            TECHNISCHE DATEN
          </div>
        </div>
        <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-4 mportal-ml-4 mportal-techdata">
          <div v-if="detailArray.gearType" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Getriebe </div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.gearType }}</div>
          </div>
          <div class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Kraftstofftyp </div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.fuelType }}</div>
          </div>
          <div class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Systemleistung </div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.displayPower }}kW ({{ ps(detailArray.displayPower) }}PS)</div>
          </div>
          <div v-if="detailArray.wltpFuelConsumptionComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionComb }} l/100km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpFuelConsumptionWeightedComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionWeightedComb }} l/100km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpFuelConsumptionChargeSustainingComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionChargeSustainingComb }} l/100km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.nedcFuelConsumptionCombined" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Verbrauch (NEFZ)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.nedcFuelConsumptionCombined }} l/100km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpCo2Comb || detailArray.wltpPureElectricRangeComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2Comb ? detailArray.wltpCo2Comb : '0' }} g/km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpCo2WeightedComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP, gew., komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2WeightedComb }} g/km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpCo2ChargeSustainingComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2ChargeSustainingComb }} g/km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.nedcCo2Combined" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">CO²-Emission (NEFZ)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.nedcCo2Combined }} g/km<sup class="mportal-text-sm">[1]</sup> <span class="mportal-px-2 mportal-py-0.5 mportal-border-black mportal-rounded-3xl mportal-border mportal-text-xs mportal-cursor-pointer" @click="showModal()">i</span></div>
          </div>
          <div v-if="detailArray.wltpEquivalentAllElectricRangeComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpEquivalentAllElectricRangeComb }} km</div>
          </div>
          <div v-if="detailArray.wltpPureElectricRangeComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpPureElectricRangeComb }} km</div>
          </div>
          <div v-if="detailArray.wltpPureElectricRangeCity" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, innerorts)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpPureElectricRangeCity }} km</div>
          </div>
          <div v-if="detailArray.wltpElectricConsumptionAcWeightedComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Energieverbrauch (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpElectricConsumptionAcWeightedComb }} kWh/100km</div>
          </div>
          <div v-if="detailArray.wltpElectricConsumptionComb" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Energieverbrauch (WLTP, komb.)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpElectricConsumptionComb }} kWh/100km</div>
          </div>
        </div>
        <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-4 mportal-ml-4 mportal-mt-16">
          <div v-if="detailArray.energyLabel" class="mportal-mt-4">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">CO²-Effizienzklasse</div>
            <div class="mportal-w-full mportal-text-left mportal-co2label mportal-mt-2">
              <img v-if="detailArray.energyLabel===`Aplusplusplus`" :src="imgpath+`label/aplusplusplus.png`" />
              <img v-if="detailArray.energyLabel===`Aplus` || detailArray.energyLabel===`AP`" :src="imgpath+`label/aplus.png`" />
              <img v-if="detailArray.energyLabel===`A`" :src="imgpath+`label/a.png`" />
              <img v-if="detailArray.energyLabel===`B`" :src="imgpath+`label/b.png`" />
              <img v-if="detailArray.energyLabel===`C`" :src="imgpath+`label/c.png`" />
              <img v-if="detailArray.energyLabel===`D`" :src="imgpath+`label/d.png`" />
              <img v-if="detailArray.energyLabel===`E`" :src="imgpath+`label/e.png`" />
              <img v-if="detailArray.energyLabel===`F`" :src="imgpath+`label/f.png`" />
              <img v-if="detailArray.energyLabel===`G`" :src="imgpath+`label/g.png`" />
            </div>
          </div>
          <div v-if="detailArray.tires.both" class="mportal-mt-4 mportal-reifenlabel">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Front & Heck)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">
              <img :src="imgpath+detailArray.tires.both" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
            </div>
          </div>
          <div v-if="detailArray.tires.front" class="mportal-mt-4 mportal-reifenlabel">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Front)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">
              <img :src="imgpath+detailArray.tires.front" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
            </div>
          </div>
          <div v-if="detailArray.tires.rear" class="mportal-mt-4 mportal-reifenlabel">
            <!-- col -->
            <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Heck)</div>
            <div class="mportal-w-full mportal-text-left mportal-font-semibold">
              <img :src="imgpath+detailArray.tires.rear" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
            </div>
          </div>
        </div>
        <div class="md:mportal-text-4xl mportal-text-2xl mportal-mx-4 mportal-text-left mportal-font-normal mportal-w-full mportal-mt-16">
          <div class="mportal-my-4">
            FAHRZEUGDETAILS
          </div>
        </div>
        <div class="mportal-text-left mportal-m-4 mportal-col-count-1 md:mportal-col-count-2 mportal-fahrezugdetails">
          <div v-for="(feature,index) in features" :key="feature" class="mportal-mb-4">
            <div class="mportal-font-bold">
              {{ index }}
            </div>
            <div v-for="inhalt in feature" :key="inhalt">
              <div>{{ inhalt }}</div>
            </div>
          </div>
        </div>
        <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-2 mportal-text-left">
          <div class="mportal-w-full mportal-float-left mportal-text-justify mportal-pl-4 md:mportal-py-4 mportal-pr-4">
            * Laufzeitgebundener Dienst, evtl. fallen zusätzliche Kosten an. Dies ist ein unverbindliches Angebot. Angebote solange der Vorrat reicht. Preisänderungen, Irrtum und Zwischenverkauf vorbehalten. Wir übernehmen keine Gewähr für die Richtigkeit der Angaben im Inserat.    Lieferzeiten können abweichen.
          </div>
          <div />
        </div>

        <div class="mportal-mx-4 mportal-mt-16">
          <div class="mportal-my-4 mportal-mt-10 md:mportal-text-4xl mportal-text-2xl mportal-text-left">
            LEASING-KONDITIONEN
          </div>
          <div class="mportal-flex mportal-flex-wrap">
            <div class="mportal-w-full md:mportal-w-1/2 mportal-text-left mportal-leasingkonditionen mportal-mb-4">
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Unverbindliche Preisempfehlung</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ numberFormat(brutto(detailArray.originalPriceTotal, true)) }} €</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Nettodarlehensbetrag</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ numberFormat(brutto(detailArray.privat_nettodarlehensbetrag, true)) }} €</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Effektiver Jahreszins</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ detailArray.privat_effektiv }} %</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Gebundener Sollzins</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ detailArray.privat_soll }} %</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Gesamtleasingbetrag</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ numberFormat(brutto(detailArray.privat_gesamtleasingbetrag_36_10, true)) }} €</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Leasingrate</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ numberFormat(brutto(detailArray.privat_leasing_36_10, true)) }} € / Mon.</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Mehr KM</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ brutto(detailArray.mehrkm, false) }} Cent</div>
              </div>
              <div class="mportal-my-1">
                <div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-font-bold lg:mportal-font-normal">Minder KM</div><div class="mportal-float-left mportal-w-full lg:mportal-w-6/12 mportal-mb-2"> {{ brutto(detailArray.minderkm, false) }} Cent</div>
              </div>
            </div>
            <div class="mportal-w-full md:mportal-w-1/2 mportal-text-left">
              <div class="mportal-w-full mportal-float-left mportal-text-justify mportal-pr-4 mportal-pb-4">
                <p>Die Leasingrate wurde berechnet für:</p>
                <p class="mportal-mb-4">10.000 km/Jahr | 36 Monate Laufzeit | 0,- € Anzahlung.</p>
                <p class="mportal-mb-4">Auf Anfrage erstellen wir Ihnen sehr gerne ein individuelles Angebot.</p>
                <p>Ein unverbindliches Leasingbeispiel der BMW Bank GmbH, Lilienthalallee 26, 80939 München, alle Preise inkl. MwSt., Stand 07/2021.</p>
              </div>
              <div class="mportal-w-full mportal-float-left mportal-text-justify mportal-pr-4 mportal-pb-4">
                Ist der Leasingnehmer Verbraucher, besteht bei außerhalb von Geschäftsräumen geschlossenen Verträgen und bei Fernabsatzverträgen nach Vertragsschluss ein gesetzliches Widerrufsrecht. Nach den Leasingbedingungen besteht die Verpflichtung, für das Fahrzeug eine Vollkaskoversicherung abzuschließen.** gebunden für die gesamte Vertragslaufzeit
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <Modal v-show="isModalVisible" @close="closeModal">
    <template #body>
      <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-2  mportal-text-left">
        <div class="mportal-col-span-2 mportal-text-4xl mportal-my-6 mportal-ml-4">
          {{ detailArray.brandcode }} {{ detailArray.description }}
        </div>
        <div class="mportal-col-span-2 mportal-text-xl mportal-mb-4">
          <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-3 mportal-ml-4">
            <div v-if="detailArray.wltpFuelConsumptionComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionComb }} l/100km</div>
            </div>
            <div v-if="detailArray.wltpFuelConsumptionWeightedComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionWeightedComb }} l/100km</div>
            </div>
            <div v-if="detailArray.wltpFuelConsumptionChargeSustainingComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Verbrauch (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpFuelConsumptionChargeSustainingComb }} l/100km</div>
            </div>
            <div v-if="detailArray.nedcFuelConsumptionCombined" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Verbrauch (NEFZ)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.nedcFuelConsumptionCombined }} l/100km</div>
            </div>
            <div v-if="detailArray.wltpCo2Comb || detailArray.wltpPureElectricRangeComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2Comb ? detailArray.wltpCo2Comb : '0' }} g/km</div>
            </div>
            <div v-if="detailArray.wltpCo2WeightedComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP, gew., komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2WeightedComb }} g/km</div>
            </div>
            <div v-if="detailArray.wltpCo2ChargeSustainingComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">CO²-Emission (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpCo2ChargeSustainingComb }} g/km</div>
            </div>
            <div v-if="detailArray.nedcCo2Combined" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">CO²-Emission (NEFZ)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.nedcCo2Combined }} g/km</div>
            </div>
            <div v-if="detailArray.wltpEquivalentAllElectricRangeComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpEquivalentAllElectricRangeComb }} km</div>
            </div>
            <div v-if="detailArray.wltpPureElectricRangeComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpPureElectricRangeComb }} km</div>
            </div>
            <div v-if="detailArray.wltpPureElectricRangeCity" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Elektrische Reichweite (WLTP, innerorts)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpPureElectricRangeCity }} km</div>
            </div>
            <div v-if="detailArray.wltpElectricConsumptionAcWeightedComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Energieverbrauch (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpElectricConsumptionAcWeightedComb }} kWh/100km</div>
            </div>
            <div v-if="detailArray.wltpElectricConsumptionComb" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Energieverbrauch (WLTP, komb.)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">{{ detailArray.wltpElectricConsumptionComb }} kWh/100km</div>
            </div>
          </div>
          <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-3 mportal-ml-4 mportal-col-span-2 mportal-my-6">
            <div v-if="detailArray.energyLabel" class="mportal-mt-4">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">CO²-Effizienzklasse</div>
              <div class="mportal-w-full mportal-text-left mportal-mt-2">
                <img v-if="detailArray.energyLabel===`Aplusplusplus`" :src="imgpath+`label/aplusplusplus.png`" />
                <img v-if="detailArray.energyLabel===`Aplus` || detailArray.energyLabel===`AP`" :src="imgpath+`label/aplus.png`" />
                <img v-if="detailArray.energyLabel===`A`" :src="imgpath+`label/a.png`" />
                <img v-if="detailArray.energyLabel===`B`" :src="imgpath+`label/b.png`" />
                <img v-if="detailArray.energyLabel===`C`" :src="imgpath+`label/c.png`" />
                <img v-if="detailArray.energyLabel===`D`" :src="imgpath+`label/d.png`" />
                <img v-if="detailArray.energyLabel===`E`" :src="imgpath+`label/e.png`" />
                <img v-if="detailArray.energyLabel===`F`" :src="imgpath+`label/f.png`" />
                <img v-if="detailArray.energyLabel===`G`" :src="imgpath+`label/g.png`" />
              </div>
            </div>
            <div v-if="detailArray.tires && detailArray.tires.both" class="mportal-mt-4 mportal-reifenlabel">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Front & Heck)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">
                <img :src="imgpath+detailArray.tires.both" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
              </div>
            </div>
            <div v-if="detailArray.tires && detailArray.tires.front" class="mportal-mt-4 mportal-reifenlabel">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Front)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">
                <img :src="imgpath+detailArray.tires.front" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
              </div>
            </div>
            <div v-if="detailArray.tires && detailArray.tires.rear" class="mportal-mt-4 mportal-reifenlabel">
              <!-- col -->
              <div class="mportal-w-full mportal-text-left">Reifen-Effizienzklasse (Heck)</div>
              <div class="mportal-w-full mportal-text-left mportal-font-semibold">
                <img :src="imgpath+detailArray.tires.rear" class="mportal-max-w-xxs mportal-mt-2 mportal-float-left" />
              </div>
            </div>
          </div>
          <div class="mportal-grid mportal-grid-cols-1 md:mportal-grid-cols-2 mportal-ml-4 mportal-col-span-2 mportal-my-6 mportal-px-4">
            <div class="mportal-w-full mportal-float-left mportal-text-justify md:mportal-pr-4 md:mportal-py-4">
              [1] Offizielle Angaben zu Kraftstoffverbrauch, CO²-Emissionen,
              Stromverbrauch und elektrischer Reichweite wurden nach dem vorgeschriebenen Messverfahren
              ermittelt und entsprechen der VO (EU) 715/2007 in der jeweils geltenden Fassung.
              Angaben im NEFZ berücksichtigen bei Spannbreiten Unterschiede in der gewählten Rad-und Reifengröße,
              im WLTP jeglicher Sonderausstattung. Für die Bemessung von Steuern und anderen fahrzeugbezogenen Abgaben,
              die (auch) auf den CO²-Ausstoß abstellen, sowie ggf. für die Zwecke von fahrzeugspezifischen
              Förderungen werden WLTP-Werte verwendet. Aufgeführte NEFZ-Werte wurden ggf. auf Basis des neuen
              WLTP-Messverfahrens ermittelt und zur Vergleichbarkeit auf das NEFZ-Messverfahren zurückgerechnet.
              Für seit 01.01.2021 neu typgeprüfte Fahrzeuge existieren die offiziellen Angaben nur noch nach WLTP.
              Weitere Informationen zu den Messverfahren NEFZ und WLTP finden Sie unter <a href="https://www.bmw.de/wltp" target="_new" class="mportal-font-bold">www.bmw.de/wltp</a>
              sowie eine Vergleichstabelle zu Kraftstoffverbrauch, CO²-Emissionen, Stromverbrauch und
              elektrischer Reichweite aller aktuellen BMW Modelle unter <a href="https://www.bmw.de/nefz-wltp-vergleich" target="_new" class="mportal-font-bold">www.bmw.de/nefz-wltp-vergleich</a>.<br />
              Weitere Informationen zum offiziellen Kraftstoffverbrauch und den offiziellen spezifischen
              CO²-Emissionen neuer Personenkraftwagen können dem 'Leitfaden über den Kraftstoffverbrauch,
              die CO²-Emissionen und den Stromverbrauch neuer Personenkraftwagen' entnommen werden, der an allen Verkaufsstellen,
              bei der Deutschen Automobil Treuhand GmbH (DAT), Hellmuth-Hirth-Str. 1, 73760 Ostfildern-Scharnhausen, und unter
              <a href="https://www.dat.de/co2/unentgeltlich" target="_new" class="mportal-font-bold">https://www.dat.de/co2/unentgeltlich</a> erhältlich ist. Abbildung/en zeigt/en Sonderausstattungen.
            </div>
            <div class="mportal-w-full mportal-float-left mportal-text-justify md:mportal-pr-4 md:mportal-py-4">
              CO²-Effizienz nach dem WLTP Messverfahren<br />
              DIESER WERT GILT AB DEM 01.01.2019<br /><br />
              Seit dem 1. September 2017 werden bestimmte Neuwagen nach dem weltweit harmonisierten Prüfverfahren für Personenwagen
              und leichte Nutzfahrzeuge (Worldwide Harmonized Light Duty Vehicles Test Procedure, WLTP), einem realistischeren
              Prüfverfahren zur Messung des Kraftstoffverbrauchs und der CO²-Emissionen, typgenehmigt. Ab dem 1. September 2018
              wird der WLTP den neuen europäischen Fahrzyklus (NEFZ) ersetzen. Wegen der realistischeren Prüfbedingungen sind
              die nach dem WLTP gemessenen Kraftstoffverbrauchs-, Stromverbrauchs-und CO²-Emissionswerte in vielen Fällen höher
              und die Reichweiten in vielen Fällen niedriger als die nach dem NEFZ gemessenen. Aktuell sind noch die NEFZ-Werte
              verpflichtend zu kommunizieren. Soweit es sich um Neuwagen handelt, die nach WLTP typgenehmigt sind, werden die o.g.
              NEFZ-Werte von den u.g. WLTP-Werten abgeleitet. Diese Werte entsprechen Ihrer aktuellen Konfiguration, wenn Sie
              Ausstattungen ändern können sich auch diese Werte ändern. Ab dem 01. September 2018 erfolgt die Bemessung der
              KFZ-Steuer auf Basis der ermittelten WLTP-Werte. Weitere Informationen zum Umweltbonus und E-Kennzeichen erhalten
              Sie bei Ihrem BMW Partner.
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
  <Anfrage v-show="isAnfrageVisible" id="mportal-anfrage-form" @close="closeAnfrage">
    <template #body>
      <div class="mportal-my-5 mportal-text-center">
        Anfrage: {{ detailArray.brandcode }} {{ detailArray.description }}
        <div class="mportal-telefon-button">
          <div class="mportal-tb-inner"><a href="tel:05222123456789"><div class="mportal-max-w-xs mportal-cursor-pointer mportal-loat-left"><div class="mportal-tel-btn mportal-loat-left" /><div class="mportal-text-lg mportal-mx5 mportal-loat-left">05222-123456789</div></div></a></div>
        </div>
        <div class="mportal-w-full" v-html="detailArray.requestForm" />
      </div>
    </template>
  </Anfrage>
  <div class="mportal-mt-5 mportal-bg-red-500 mportal-pt-2 mportal-pb-2 mportal-clear-both">
    <b class="mportal-text-white">
      Diese Seite wird nur für Demo Zwecke verwendet - Die Fahrzeuge stehen nicht zum Verkauf - This case study was developed for demonstration purposes only
    </b>
  </div>
</template>
<script>
import {ref} from 'vue'
import {
  Dialog,
  DialogOverlay,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {FilterIcon, MinusSmIcon, PlusSmIcon} from '@heroicons/vue/solid'
import axios from 'axios'
import Modal from '/src/components/Modal'
import Anfrage from '/src/components/Anfrage'
import {VueAgile} from 'vue-agile'

export default {
  components: {
    Dialog,
    DialogOverlay,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    TransitionChild,
    TransitionRoot,
    FilterIcon,
    MinusSmIcon,
    PlusSmIcon,
    XIcon,
    Modal,
    Anfrage,
    VueAgile,
  },
  setup() {
    const mobileFiltersOpen = ref(false)

    return {
      mobileFiltersOpen,
    }
  },
  data: () => ({
    apiBaseUrl: process.env.NODE_ENV === 'production' ? 
      process.env.VUE_APP_API_BASE_URL_PROD :
      process.env.VUE_APP_API_BASE_URL_DEV,
    apiKey: process.env.NODE_ENV === 'production' ?
      process.env.VUE_APP_API_KEY_PROD :
      process.env.VUE_APP_API_KEY_DEV,
    hubdata:[],
    lastPage: 0,
    detailArray:[],
    view:'listing',
    page:1,
    res:[],
    weiterbl:19,
    imgpath:'https://cdn.mportal.de/CDN/',
    filters:[],
    filterselected:[],
    features:[],
    mwst:19,
    path:'bmw',
    screenweite:0,
    isModalVisible: false,
    isAnfrageVisible:false,
    sliderOptions: {
      dots: true,
      fade: false,
      navButtons: false,
    },
    errors:[],
    datenschutz: false,
    asNavFor1: [],
    asNavFor2: [],
    options1: {
      dots: true,
      fade: false,
      navButtons: true,
    },
    options2: {
      autoplay: false,
      centerMode: false,
      dots: false,
      navButtons: false,
      slidesToShow: 0,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
          },
        },    
        {
          breakpoint: 1000,
          settings: {
            navButtons: true,
          },
        },
      ],
    },
    slides: [],
    imagesLoaded: [],
  }),
  computed:{
    now: function () {
      let self=this
      self.getUrlParam()
      var datum=new Date()
      var monat=datum.getMonth()+1
      var jahr=datum.getFullYear()
      return monat+'/'+jahr
    },
    detailImagesArr: function () {
      return Object.keys(this.detailArray.images).map((key) => {
        return this.imgpath + this.detailArray.images[key]
      })
    },
    loadingListing: function (){
      return JSON.parse(JSON.stringify(this.hubdata)).every(v => this.imagesLoaded.includes(v.images.front))
    },
  },
  watch: {
    filterselected() {
      this.$nextTick(function () {
        let self = this
        // Cancel pending call
        clearTimeout(this._timerId)

        // Delay new call
        this._timerId = setTimeout(() => {
          self.getListing(true)
        }, 100)
      })
    },
  },
  async created() 
  {
    let self = this
    let url = new URL(window.location)

    // Url api key
    if(window.location.pathname !== '/'){
      let pathArray = window.location.pathname.split('/')
      if(pathArray.length >= 2){
        self.apiKey = pathArray[1]
      }
    }
    /* Get Parameter
    if (url.searchParams.get('apiKey')) {
      self.apiKey=url.searchParams.get('apiKey')
    }
     */
    // Wordpress
    if (window.mportalapikey)
    {
      self.apiKey=window.mportalapikey
    }
    /** 
    if (this.$refs.mportalAK) {
      self.apiKey=this.$refs.mportal
    }
    */
    if (url.searchParams.get('v')) {
      let vehicleNumber=url.searchParams.get('v')
      self.gotToDetail(vehicleNumber)
    }
    if (url.searchParams.get('filter')) {
      let urlParam=url.searchParams.get('filter').split(',')
      if (urlParam.length>0)
      {
        self.filterselected=urlParam
      }
    }

    // Inifinity Scolling
    window.addEventListener('scroll', this.loadItems)
    // Forma abschicken
    window.addEventListener('submit', this.processSignupForm)
    try {
      await this.getListing()
    } 
    catch (err)
    {
      console.log(err)
    }
  },
  mounted () {
    window.addEventListener('popstate', this.backbtn, false)
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.backButton)
  },
  methods: {
    scrolltop() {
      setTimeout(function(){
        window.scrollTo(0,0)
      },0.1)
    },
    processSignupForm: function (e) {
      if (document.getElementById('datenschutz').getElementsByTagName('input')[0].checked==false) {
        alert('Sie müssen die Datenschutzbestimmungen akzeptieren.')
      }
      if (document.getElementById('datenschutz').getElementsByTagName('input')[0].checked==true) {
        return true
      }
      e.preventDefault()
      return false
    },
    loadItems()
    {
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

      if (bottomOfWindow && this.lastPage > this.page) {
        this.shownext()
      }
    },
    getListing(reset = false)
    {
      /** Aufruf Listing bei Änderung eines Filters */
      let self = this
      const config = {
        headers: {
          'Accept': 'application/json',
        },
      }
      if(reset){
        self.page = 1
      }
      self.pushUrlOptions(this.filterselected.join(','))
      if (this.filterselected.join(',')==='')
      {
        let url = new URL(window.location)
        let params = new URLSearchParams(url.search)
        params.delete('filter')
        url.search=params
        //let query = Object.assign({}, this.$route.query)
        //delete query.filter
        //this.$router.replace({ query })
        window.history.pushState({}, '', url)
      }
      axios.get(this.apiBaseUrl + '/' + this.apiKey + '/cars?page=' + this.page + '&filter=' + this.filterselected.join(','), config).then(function(response){
        if(reset){
          self.hubdata = []
        }
        self.res=response
        self.hubdata=[].concat(self.hubdata,self.res.data.data)
        self.filters = self.res.data.filter
        self.lastPage = self.res.data.last_page
      }).catch(function (){
        self.view = 'error'
      })
    },
    backbtn(){
      if(this.view==='detail'){
        this.getUrlParam()
        this.gotToList()
      }
    },
    backButton(){
      let url = new URL(window.location)
      let params = new URLSearchParams(url.search)
      params.delete('v')
      url.search=params
      window.history.pushState({}, '', url)

      this.view='listing'
    },
    gotToDetail(vehicleNumber){
      /** Aufruf der Detailseite */
      let self = this
      const config = {
        headers: {
          'Accept': 'application/json',
        },
      }
      let url = new URL(window.location)
      url.searchParams.set('v',vehicleNumber)
      window.history.pushState({}, '', url)

      axios.get(this.apiBaseUrl + '/' + self.apiKey + '/cars/' + vehicleNumber, config).then(function(response){
        self.res=response
        self.detailArray = self.res.data
        self.features=self.detailArray.features
        self.view='detail'
        window.scrollTo(0,0)
      })
    },
    gotToList()
    {
      let self = this
      self.getUrlParam()
      // Aufruf Listing
      self.view='listing'
    },
    shownext()
    {
      this.page++
      this.getListing()
    },
    numberFormat(val)
    {
      let price = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Math.ceil(val))
      price=price.toString().substring(0, price.length-5)
      return price
    },
    brutto(preis, ceil) {
      preis=preis*(19/100+1)
      if(ceil) {
        return Math.ceil(preis)
      }
      return parseFloat(preis).toFixed(2)
    },
    checkPath()
    {
      let self=this
      let path=window.location.href
      let pathArray=path.split('?')
      for (let i=0; i<pathArray.length; i++)
      {
        let werte=pathArray[i].split('=')
        for (let z=0; z<werte.length; z++)
        {
          if (werte[z].substring(0,3)==='BMN')
          {
            self.gotToDetail(werte[z])
          }
        }
      }
    },
    ps(v)
    {
      let ps=(v * 1.36)
      return new Intl.NumberFormat().format(Math.round(ps))
    },
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    showAnfrage() {
      this.isAnfrageVisible = true
    },
    closeAnfrage() {
      this.isAnfrageVisible = false
    },
    getFilterValues: function (options) {
      return Object.values(options).map((x) => x.value)
    },
    getUrlParam()
    {
      let self = this
      let urlParam = []
      
      if(self.$route.query && self.$route.query.filter){
        urlParam=self.$route.query.filter.split(',')
      }
      
      if (urlParam.length>0)
      {
        self.filterselected=urlParam
      }
    },
    pushUrlOptions(filterwerte)
    {
      if (filterwerte && filterwerte.substring(0,1)===',')
      {
        filterwerte=filterwerte.substring(1,filterwerte.length)
      }

      let url = new URL(window.location)

      if(filterwerte){
        url.searchParams.set('filter',filterwerte)
      }
      window.history.pushState({}, '', url)
    },
    onLoadImage(vehicleImage){
      if(!this.imagesLoaded.includes(vehicleImage)){
        this.imagesLoaded.push(vehicleImage)
      }
    },
  },
}
</script>
<style>
table tr td:first-child
{
  text-align: left;  
}
table tr td:nth-child(2)
{
  text-align: right;
}
.mportal-max-w-xxs {
  max-width: 10rem;
}
.mportal-max-w-xs {
  max-width: 21rem !important;
}
.mportal-btn-back-icon
{
    width: 10px;
    height: 30px;
    background-image: url(data:image/png;base64,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);
    background-size: 8px;
    background-position: 0px 15px;
    background-repeat: no-repeat;
    float: left;
}
.mportal-tel-btn
{
    width: 21px;
    height: 30px;
    background-image: url(data:image/png;base64,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);
    background-size: 13px;
    background-position: 0 7px;
    background-repeat: no-repeat;
    float: left;
}

.mportal-agile__actions {
  margin-top: 20px;
}

.mportal-agile__dot {
  margin: 0 10px;
}

.mportal-agile__dot button {
  background-color: #888;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}

.mportal-agile__dot--current button, .mportal-agile__dot:hover button {
  background-color: #222;
}

.mportal-slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.mportal-slide-fade-enter-from,
.mportal-slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.mportal-delivery 
{
  color:rgba(27, 94, 201, 1);
  font-weight: 500;
}
.mportal-originalpricetotal,
.mportal-leasing-pm
{
  font-weight: 600;
}
/*Basic VueAgile styles*/
.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: transparent;
  cursor: pointer;
  font-size: 24px;
  transition-duration: 0.3s;
}
.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.thumbnails .agile__nav-button--prev {
  left: -45px;
}
.thumbnails .agile__nav-button--next {
  right: -45px;
}
.agile__nav-button:hover {
  color: transparent;
}
.agile__dot {
  margin: 210px 10px !important;
}
.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #888;
}

.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 350px;
  justify-content: center;
}
.slide--thumbniail {
  cursor: pointer;
  height: 100px;
  padding: 0 5px;
  transition: opacity 0.3s;
}
.slide--thumbniail:hover {
  opacity: 0.75;
}
.slide img {
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}
.thumbnails .agile__nav-button--next {
    right: -45px;
    display: none;
}
.agile__dots
{
  display: none;
}
.agile__list
{
  margin: 10px 0 0 0;
}
.agile__nav-button--next 
{
  background-color: rgba(179, 179, 179,0.5);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMC43MjIgNC4yOTNjLS4zOTQtLjM5LTEuMDMyLS4zOS0xLjQyNyAwLS4zOTMuMzktLjM5MyAxLjAzIDAgMS40MmwxMS4yODMgMTAuMjgtMTEuMjgzIDEwLjI5Yy0uMzkzLjM5LS4zOTMgMS4wMiAwIDEuNDIuMzk1LjM5IDEuMDMzLjM5IDEuNDI3IDBsMTIuMDA3LTEwLjk0Yy4yMS0uMjEuMy0uNDkuMjg0LS43Ny4wMTQtLjI3LS4wNzYtLjU1LS4yODYtLjc2TDEwLjcyIDQuMjkzeiIKICAgICAgICAgIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjAuOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPg==');
  background-repeat: no-repeat;
  background-position: 4px 3px;
  background-size: 30px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
.agile__nav-button--next:hover 
{
  background-color: rgba(179, 179, 179,0.8);
}
.agile__nav-button--prev 
{
  background-color: rgba(179, 179, 179,0.5);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS40MzMgMTUuOTkyTDIyLjY5IDUuNzEyYy4zOTMtLjM5LjM5My0xLjAzIDAtMS40Mi0uMzkzLS4zOS0xLjAzLS4zOS0xLjQyMyAwbC0xMS45OCAxMC45NGMtLjIxLjIxLS4zLjQ5LS4yODUuNzYtLjAxNS4yOC4wNzUuNTYuMjg0Ljc3bDExLjk4IDEwLjk0Yy4zOTMuMzkgMS4wMy4zOSAxLjQyNCAwIC4zOTMtLjQuMzkzLTEuMDMgMC0xLjQybC0xMS4yNTctMTAuMjkiCiAgICAgICAgICBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIwLjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=');
  background-repeat: no-repeat;
  background-position: 1px 3px;
  background-size: 30px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
.agile__nav-button--prev:hover 
{
  background-color: rgba(179, 179, 179,0.8);
}
.agile__actions {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 8rem;
    width: 100%;
}

.mportal-lds-ellipsis-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mportal-lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.mportal-lds-ellipsis div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #305dc2;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.mportal-lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: mportal-lds-ellipsis1 0.6s infinite;
}

.mportal-lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: mportal-lds-ellipsis2 0.6s infinite;
}

.mportal-lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: mportal-lds-ellipsis2 0.6s infinite;
}

.mportal-lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: mportal-lds-ellipsis3 0.6s infinite;
}

@keyframes mportal-lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes mportal-lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes mportal-lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@media only screen and (min-width: 400px) {
  .agile__actions {
    top: 10rem;
  }
}
@media only screen and (min-width: 440px) {
  .agile__actions {
     top: 10rem;
  }
}
@media only screen and (min-width: 562px) {
  .agile__actions {
     top: 12rem;
  }
}
@media only screen and (max-width: 700px) {
  .agile__dots
  {
    display: flex;
  }
  .slide--thumbniail
  {
    display: none;
  }
  .agile__actions {
    margin-top:165px !important;
    text-align: center;
    width: 100%;
    max-height: 30px;
  }
}

</style>
